import React, { useEffect, useState } from "react";
import { useOutletContext } from "react-router-dom";
import Constants from "../../data/Constants";
import { getStatistics } from "../../services/admin.service";
import Utils from "../../utils";
import Chart from "react-apexcharts";
import moment from "moment";
import { MenuItem, Select } from "@mui/material";
function Statistics(props) {
  const { setProgress, setToast, isRefreshed } = useOutletContext();

  const [stats, setStatistics] = useState();
  const [filters, setFilters] = useState({
    interval: "weekly",
  });
  const [payment, setPayment] = useState();
  const [payroll, setPayroll] = useState();

  const parseDataForPaymentGraph = (payments) => {
    const map = {};

    const mOptions = {
      series: [
        {
          name: "",
          data: [],
        },
      ],
      chart: {
        type: "line",
        zoom: {
          enabled: false,
        },
      },
      dataLabels: {
        enabled: true,
      },
      stroke: {
        width: 2,
        curve: "smooth",
      },
      title: {
        text: "",
        align: "left",
      },
      grid: {
        row: {
          colors: ["transparent"], // takes an array which will be repeated on columns
          opacity: 0.5,
        },
      },
      xaxis: {
        categories: [],
      },
    };

    for (let payment of payments) {
      const date = moment(payment.updatedAt).format("DD-MM-YYYY");

      if (map[date]) {
        map[date] += payment.amount;
      } else {
        map[date] = payment.amount;
      }
    }

    mOptions.series[0].name = "Payments";
    mOptions.series[0].data = Object.values(map);
    mOptions.xaxis.categories = Object.keys(map);
    mOptions.title.text = "Payment Trends by Week";
    return mOptions;
  };

  const parseDataForPayrollGraph = (payrolls) => {
    const map = {};
    const mOptions = {
      series: [
        {
          name: "",
          data: [],
        },
      ],
      chart: {
        type: "line",
        zoom: {
          enabled: false,
        },
      },
      dataLabels: {
        enabled: true,
      },
      stroke: {
        width: 2,
        curve: "smooth",
      },
      title: {
        text: "",
        align: "left",
      },
      grid: {
        row: {
          colors: ["transparent"], // takes an array which will be repeated on columns
          opacity: 0.5,
        },
      },
      xaxis: {
        categories: [],
      },
    };
    for (let payroll of payrolls) {
      const date = moment(payroll.completedAt).format("DD-MM-YYYY");

      if (map[date]) {
        map[date] += payroll.amount;
      } else {
        map[date] = payroll.amount;
      }
    }

    mOptions.series[0].name = "Payroll";
    mOptions.series[0].data = Object.values(map);
    mOptions.xaxis.categories = Object.keys(map);
    mOptions.title.text = "Payroll Trends by Week";
    return mOptions;
  };

  useEffect(() => {
    async function api() {
      setProgress(true);
      try {
        const data = await getStatistics(filters);
        setProgress(false);
        if (data) {
          setPayment(parseDataForPaymentGraph(data.payments));
          setPayroll(parseDataForPayrollGraph(data.payrolls));
          setStatistics(data);
        } else {
          // error
          setToast({ error: true, message: Constants.Error.UNKNOWN });
        }
      } catch (error) {
        // error
        console.log(error);
        setProgress(false);
        setToast({
          error: true,
          message: Utils.CustomErrorMessage(error),
        });
      }
    }
    api();
  }, [isRefreshed, filters]);

  return (
    stats && (
      <div className="flex flex-col gap-8">
        <div className="flex justify-end">
          <Select
            value={filters.interval}
            size="small"
            onChange={(e) => {
              setFilters({ ...filters, interval: e.target.value });
            }}
          >
            <MenuItem value="weekly">Weekly</MenuItem>
            <MenuItem value="monthly">Monthly</MenuItem>
            <MenuItem value="yearly">Yearly</MenuItem>
          </Select>
        </div>
        <div className="w-full grid md:grid-flow-col grid-flow-row gap-10">
          <div className=" h-44 text-center bg-blue-100 shadow-xl rounded-lg border-primary text-primaryDark p-5 items-center justify-center flex flex-col">
            <div className="text-5xl m-5">{stats.total.courses}</div>
            <h1 className="font-extrabold uppercase text-sm">Total Courses</h1>
            <h1 className="text-sm">(All)</h1>
          </div>

          <div className=" h-44 text-center bg-blue-100 shadow-xl rounded-lg border-primary text-primaryDark p-5 items-center justify-center flex flex-col">
            <div className="text-5xl m-5">
              {Math.floor((stats.total.sessionTime / 60) * 100) / 100}
            </div>
            <h1 className="font-extrabold uppercase text-sm">
              Total Session (Hours)
            </h1>
            <h1 className="text-sm">(All)</h1>
          </div>
          <div className="h-44 text-center bg-blue-100 shadow-xl rounded-lg border-primary text-primaryDark p-5 items-center justify-center flex flex-col">
            <div className="text-5xl m-5">{stats.weekly.mentors}</div>
            <h1 className="font-extrabold uppercase text-sm">New Mentors</h1>
            <h1 className="text-sm">({filters.interval})</h1>
          </div>
          <div className="h-44 text-center bg-blue-100 shadow-xl rounded-lg border-primary text-primaryDark p-5 items-center justify-center flex flex-col">
            <div className="text-5xl m-5">{stats.weekly.mentees}</div>
            <h1 className="font-extrabold uppercase text-sm">New Mentees</h1>
            <h1 className="text-sm">({filters.interval})</h1>
          </div>

          <div className="h-44 text-center bg-blue-100 shadow-xl rounded-lg border-primary text-primaryDark p-5 items-center justify-center flex flex-col">
            <div className="text-5xl m-5">{stats.weekly.coursesBought}</div>
            <h1 className="font-extrabold uppercase text-sm">
              New Courses Bought
            </h1>
            <h1 className="text-sm">({filters.interval})</h1>
          </div>
        </div>
        <div className="grid md:grid-flow-col grid-flow-row h-full w-full">
          <div>
            {payment && (
              <Chart options={payment} series={payment.series} type="line" />
            )}
          </div>

          <div>
            {payroll && (
              <Chart options={payroll} series={payroll.series} type="line" />
            )}
          </div>
        </div>
      </div>
    )
  );
}
export default Statistics;
